import { ContactForm } from '../components/forms/ContactForm';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

const contactInfo = [
  {
    icon: Mail,
    title: 'Email',
    value: 'admin@niyanta.io',
    href: 'mailto:admin@niyanta.io',
  },
  {
    icon: Phone,
    title: 'Phone',
    value: '+91-78146-51194',
    href: 'tel:+917814651194',
  },
  {
    icon: MapPin,
    title: 'Address',
    value: 'Unit no 309, Tower A, Saas Tower, Medicity, Gurgaon',
    href: null,
  },
  {
    icon: Clock,
    title: 'Business Hours',
    value: 'Mon - Fri: 9:00 AM - 6:00 PM',
    href: null,
  },
];

export const ContactPage = () => {
  return (
    <div className="min-h-screen pt-20" data-testid="contact-page">
      {/* Hero Banner */}
      <section className="py-20 md:py-28 hero-glow" data-testid="contact-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="inline-block px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6 animate-fade-in-up">
            Contact Us
          </span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold font-heading text-white animate-fade-in-up stagger-1">
            Get in Touch
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground mt-6 max-w-2xl mx-auto animate-fade-in-up stagger-2">
            Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-24 md:py-32" data-testid="contact-main">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Contact Info */}
            <div className="space-y-8 animate-fade-in-up">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold font-heading text-white mb-4">
                  Contact Information
                </h2>
                <p className="text-muted-foreground text-lg">
                  Reach out to us through any of the following channels.
                </p>
              </div>

              <div className="grid sm:grid-cols-2 gap-6">
                {contactInfo.map((info, index) => (
                  <div
                    key={info.title}
                    className={`glass rounded-xl p-6 card-hover animate-fade-in-up stagger-${index + 1}`}
                    data-testid={`contact-info-${info.title.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    <div className="feature-icon mb-4">
                      <info.icon className="w-5 h-5" />
                    </div>
                    <h3 className="text-white font-semibold font-heading mb-2">
                      {info.title}
                    </h3>
                    {info.href ? (
                      <a
                        href={info.href}
                        className="text-muted-foreground hover:text-primary transition-colors"
                      >
                        {info.value}
                      </a>
                    ) : (
                      <p className="text-muted-foreground">{info.value}</p>
                    )}
                  </div>
                ))}
              </div>

              {/* Map Placeholder */}
              <div className="glass rounded-2xl overflow-hidden h-[300px] animate-fade-in-up stagger-4" data-testid="contact-map">
                <div className="w-full h-full bg-secondary/50 flex items-center justify-center">
                  <div className="text-center">
                    <MapPin className="w-12 h-12 text-primary mx-auto mb-4" />
                    <p className="text-muted-foreground">
                      Unit no 309, Tower A,<br />
                      Saas Tower, Medicity, Gurgaon
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="glass rounded-2xl p-8 animate-fade-in-up stagger-2" data-testid="contact-form-wrapper">
              <h3 className="text-2xl font-semibold font-heading text-white mb-6">
                Send us a Message
              </h3>
              <ContactForm
                formType="Contact Page Inquiry"
                showInterestedIn={true}
                showSubject={true}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
